<template> 
  <div style="height: 100vh;overflow-y:hidden;" :style="{'background':'linear-gradient(180deg, #22C9FE 0%, #0172F2 100%)'}"> 
    <div class="machine-head" style="font-size:60px;letter-spacing:10px;height:120px;line-height:120px;
  text-shadow: 2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000;position:relative" :style="{'color':'#fff','background':'#ea0000'}">
      <img style="width:100px;margin-right:10px;  ; position: absolute;" :src="row.score_logo?row.score_logo:'https://wa.ccachina.net/img/logo.58b57af4.png'" /> 
      <div style=" text-align:center">{{ row.title }}
        实时成绩
      </div>
        <img style="width:100px;position: absolute; float:right;top:20px;right:20px" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <!-- <div>{{ row.saiqu_name }}</div> -->
    </div>
    <div style="background-image: linear-gradient(#f9f400 0%, #f9f400 48%, #f9f400 100%);
    height: 100px;
    letter-spacing:0.2em; 
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
    line-height: 100px;
    margin: 10px;
    text-align: center;
    color: #000;
    font-size: 50px;
    padding: 0px 20px;
    font-weight: bold;
    ">{{start.subject_name}}</div>
    <div style="background-image: linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%);
    height:auto;line-height:140px; margin:10px;text-align:left;color:#ffffffcc;font-size:80px;padding:0;
     font-weight:bold
    ">
    <div style="display: inline-block; padding:0 20px;font-size:70px;  background-image: linear-gradient(180deg, #9343FE 0%, #5A1AC9 48%, #9343FE 100%);text-align:center;margin-right:10px">
     出场顺序 {{thisIndex+1}}
    </div>
    {{start.mingcheng}}</div>

    <!-- <div class="machine-box" :style="'height:' + (clientHeight -104 - 20) + 'px;'"> -->
    <div class="machine-box"  style="margin:10px;height:100%;background-image: linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%);" :style="{'color':row.show_font_color}">
      <div class="machine-content">
        <!-- <div class="machine-subject">{{start.subject_name}}</div> -->
        <!-- <div class="machine-army">{{start.mingcheng}}</div> -->

        <table class="machine-table" :style="{'color':row.show_font_color_2}">
          <thead>
          <tr style="color:#ca9a9a">
            <th>得分</th>
            <th  >裁判长减分</th>
            <th v-if="start.saiqu==655||start.saiqu==654||start.saiqu==852||start.saiqu==853">公益视频加分</th> 
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style="padding:20px;">
              <div v-if="start.status==2" style="background-image:   border-radius:10px;color:#ffffffcc;">{{ (parseFloat(start.score_total)+parseFloat(start.score_pen)-parseFloat(start.score_add)).toFixed(3) }}</div>
                <div v-else style="background-image:   border-radius:10px;color:#ffffffcc;"> - </div>
              </td> 
            <td style="padding:20px;">
              <div v-if="start.score_pen>0" style="background-image:   border-radius:10px;color:#ffffffcc;line-height:150px;min-height:204.797px">{{ start.status==2?start.score_pen:'' }}
              <p style="color:#fff;font-size:46px;line-height:46px">{{start.status==2?start.comment_pen:''}}</p>
              </div>
              <div v-else style="background-image: ; border-radius:10px;color:#ffffffcc;">{{ start.status==2?start.score_pen:'' }} </div>
            </td>
            <td  v-if="start.saiqu==655||start.saiqu==654||start.saiqu==852||start.saiqu==853" style="padding:20px;" ><div style="background-image: ; border-radius:10px;color:#ffffffcc;">{{ start.status==2?start.score_add:'' }} </div></td> 
             
          </tr>
          </tbody>

        </table> 

        <table class="machine-table" :style="{'color':row.show_font_color_2}">
          <thead>
          <tr style="color:#ca9a9a">
            <th>当前排名</th> 
            <th>总分</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style="padding:20px;"><div style="background-image: linear-gradient(180deg, #E04063 0%, #B71C3E 48%, #E04063 100%); border-radius:10px;color:#ffffffcc;">{{ start.status==2?currentRank:'-' }}</div></td>
             <td style="padding:20px;"><div style="background-image: linear-gradient(180deg, #09BA83 0%, #007650 48%, #09BA83 100%); border-radius:10px;color:#ffffffcc;">
              {{ start.status==2?start.score_total:'-' }}
              </div>
            </td>
          </tr>
          </tbody>

        </table>
      </div>

    </div>


  </div>
</template>
<style scoped>
  
body {
  overflow-y: hidden;
}

.machine-table {
  /* margin-top: 80px; */
  width: 100%;
  /* color: #E3E59D; */
}

.machine-box {
  /* background: #0782B8; */
  text-align: center;
  /* color: #fff; */
  display: flex;
  justify-content: center; /*使子项目水平居中*/
  /*align-items: center; !*使子项目垂直居中*!*/
}

.machine-content {
  margin: 30px 0 0;
  width: 90%;
}

.machine-content .machine-subject {
  font-size: 46px;
}

.machine-content .machine-army {
  font-size: 46px;
  margin-top: 20px;
  font-weight: 500;
}

.machine-box .machine-subject, .machine-box .machine-army {
  /*display: inline-block;*/
}

table {
  /* color: #E3E59D; */
  table-layout: fixed; 
  width: 100%;
}

table thead th {
  font-size: 80px;
  letter-spacing: 0.2em;
  font-weight: bold;
}

table tbody {
  font-size: 128px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}

table th, table td {
  height: 50px; 
}

table thead th:first-child, table tbody td:first-child {
  /* width: 80%; */
  text-align: center;
}

table thead th:last-child, table tbody td:last-child {
  /*width: 80%;*/
  text-align: center;
}


table thead th, table tbody td {
  /* min-width: 25%;  */
}


.pointer {
  cursor: pointer;
}

.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 20px;
  text-align: left;
  font-size: 36px;
  /* color: #fff; */
  font-weight: bold;
}


.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


</style>
<script>

export default {
  name: 'ScoreStartMachineRank',
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    start: {
      type: Object,
      default: () => {}
    },
    list:{
      type: Array,
      default: []
    }
  },
  components: {
  },
  data() {
    return {
      loading: false,
      thisIndex:0,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      lastIndex: -1,
      currentRank:'-',
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,

      scoreList: [],
      formData: {
        id: 0
      },

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  watch:{
    list(){ 
      let that = this
      console.log('watch list')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          if(that.lastIndex != index){
            that.currentRank = item.rank
            that.lastIndex = index
          }
          if(!that.currentRank && item.rank>0){
            //兼容一次队伍 一直显示-的问题
            that.currentRank = item.rank;
          }

          return 
        }  
      }) 
    },
    start(){ 
      let that = this
      console.log('watch start')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index 
          return 
        }  
      }) 
    }
  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '队伍信息'
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: {},
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// ScoreStartRank2.vue?34bfcc94